import React from 'react';
import Header2 from '../components/header2/header2';
import Footer from '../components/Footer/Footer';
import IncludedFeatures from '../components/All_Features/included';


function Features() {
  return (
    <div className="App">
      <Header2 />  
      <IncludedFeatures />
      <Footer/>
    </div>
  )
}

export default Features;